import { PaintedScene } from '../PaintedScene';

export const JUGGERNAUTS_HEARTH_PHASER_KEY = 'JuggernautsHearthScene' as const;
export const JUGGERNAUTS_HEARTH_MANIFEST_KEY = 's-402-juggernauts-hearth' as const;

export class JuggernautsHearthScene extends PaintedScene {
  constructor() {
    super(JUGGERNAUTS_HEARTH_PHASER_KEY, JUGGERNAUTS_HEARTH_MANIFEST_KEY);
  }
}
